/**
 * Sync Store
 * Verwaltet Synchronisations-Status
 */

import { writable, derived } from 'svelte/store';
import type { SyncStatus } from '../types';
import { syncService } from '../services/sync';

function createSyncStore() {
  const initialState: SyncStatus = syncService.getStatus();

  const { subscribe, set, update } = writable<SyncStatus>(initialState);

  // Sync Service Listener registrieren
  syncService.onStatusChange((status) => {
    set(status);
  });

  // Online/Offline Events
  if (typeof window !== 'undefined') {
    window.addEventListener('online', () => {
      update((state) => ({ ...state, isOnline: true }));
      syncService.syncAll().catch(console.error);
    });

    window.addEventListener('offline', () => {
      update((state) => ({ ...state, isOnline: false }));
    });
  }

  return {
    subscribe,

    /**
     * Startet Synchronisation
     */
    async sync(): Promise<void> {
      try {
        await syncService.syncAll();
      } catch (error) {
        console.error('Sync fehlgeschlagen:', error);
        throw error;
      }
    },

    /**
     * Retry für fehlgeschlagene Syncs
     */
    async retry(): Promise<void> {
      await syncService.retryFailedSyncs();
    },

    /**
     * Aktualisiert Status manuell
     */
    refresh(): void {
      set(syncService.getStatus());
    }
  };
}

export const syncStore = createSyncStore();

/**
 * Derived Store: Ist Online
 */
export const isOnline = derived(syncStore, ($sync) => $sync.isOnline);

/**
 * Derived Store: Ist Synchronisation aktiv
 */
export const isSyncing = derived(syncStore, ($sync) => $sync.isSyncing);

/**
 * Derived Store: Anzahl ausstehender Items
 */
export const pendingItems = derived(syncStore, ($sync) => $sync.pendingItems);

